import React from "react";
import "./index.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© {new Date().getFullYear()} 
          <a href="https://wensystem.com.br" target="_blank" rel="noopener noreferrer">
            Wensystem
          </a>
          . Todos os direitos reservados. 
          <img className="footer-logo"
            src="https://wensystem.com.br/wp-content/uploads/elementor/thumbs/wen-p623lz4kkweo04kemh8w9xxnnnil4y52p7qm1kzev8-q2udnzzadgwf28zy01to57p9qt3p3g9kjh2rvsjzzc.png" alt="Logo Wensystem" />
        </p>
        <div>Versão: 31/08/2026 11:50</div>
      </div>
      
    </footer>
  );
};

export default Footer;